import apiUrl from '../../../utils/settings';

export const getSearchProductsUrl = () => {
  return apiUrl + `/v2/search/`;
};
export const getCompanySuppliersUrl = () => {
  return apiUrl + '/company/suppliers';
};
export const searchCompanyUrl = () => {
  return apiUrl + '/company/search';
};

export const moduleWiseEntityUrl = () => {
  return apiUrl + '/company/module-wise-entities';
};

